import { useMoveToFragmentScreens } from './moveToFragmentScreens';

export const useScreensNavigator = () => {
  const moveToFragmentScreens = useMoveToFragmentScreens();

  return {
    moveToFragmentScreens,
  };
};
